// extracted by mini-css-extract-plugin
export default {"container":"container-kkcRVQqF","points":"points-aE0V6ZTk"};